import withPlatform from '../../withPlatform/withPlatform';
import Popper from '../Popper';
import MobilePopper from './MobilePopper';
export default withPlatform()(Popper, MobilePopper);